import { defineStore } from "pinia";

export const useSearchModuleStore = defineStore({
    id: "searchModule",
    state: () => ({
        query: "",
        resultsVisibility: false
    }),
    getters: {
        getQuery: state => {
            // console.log("useSearchModuleStore getQuery", state.query);
            return state.query;
        },
        getResultsVisibility: state => {
            // console.log("useSearchModuleStore getVisible", state.resultsVisibility);
            return state.resultsVisibility;
        }
    },
    actions: {
        setQuery(query: string): void {
            // console.log("useSearchModuleStore getQuery this.query , query", this.query, query);
            this.query = query;
        },
        setResultsVisibility(resultsVisibility: boolean): void {
            // console.log(
            //     "useSearchModuleStore setResultsVisibility this.resultsVisibility , resultsVisibility ",
            //     this.resultsVisibility,
            //     resultsVisibility
            // );
            if (this.resultsVisibility !== resultsVisibility) {
                this.resultsVisibility = resultsVisibility;
            }
        },
        toggleResultsVisibility(): void {
            // console.log(
            //     "useSearchModuleStore toggleResultsVisibility this.resultsVisibility , resultsVisibility ",
            //     this.resultsVisibility,
            //     !this.resultsVisibility
            // );
            this.resultsVisibility = !this.resultsVisibility;
        }
    }
});
